import { Badge, Tooltip } from '@usealloy/component-library';
import { useEffect, useState } from 'react';

const formatTimeLeft = (ms: number): string => {
  if (ms <= 0) return '00:00';

  const days = Math.floor(ms / (1000 * 60 * 60 * 24));
  const hours = Math.floor((ms % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((ms % (1000 * 60)) / 1000);

  if (days > 0) {
    return `${days}D`;
  }
  if (hours > 0) {
    return `${hours.toString()}H:${minutes.toString().padStart(2, '0')}M`;
  }
  return `${minutes.toString()}M:${seconds.toString().padStart(2, '0')}S`;
};

export const RbacCountdown = ({ expiredAt }: { expiredAt: number }) => {
  const [timeLeft, setTimeLeft] = useState(() => {
    const diff = expiredAt - Date.now();
    return Math.max(0, diff);
  });

  useEffect(() => {
    const initial = expiredAt - Date.now();
    setTimeLeft(Math.max(0, initial));

    if (initial <= 0) return undefined;

    const interval = setInterval(() => {
      const diff = expiredAt - Date.now();
      if (diff <= 0) {
        setTimeLeft(0);
        clearInterval(interval);
        return;
      }
      setTimeLeft(diff);
    }, 1000);

    return () => clearInterval(interval);
  }, [expiredAt]);

  return (
    <Tooltip
      side="bottom"
      content={(
        <>
          Customer Account access will expire at{' '}
          {new Date(expiredAt).toLocaleString(undefined, {
            dateStyle: 'short',
            timeStyle: 'short',
          })}
        </>
      )}
    >
      <Badge
        style={{
          borderRadius: '9999px', // theme.borderRadius.full,
          border: 'none',
          userSelect: 'none',
        }}
        backgroundColor="#CCCCC4"
      >
        {formatTimeLeft(timeLeft)}
      </Badge>
    </Tooltip>
  );
};
